<template>
  <div>
    <el-carousel
      style="text-align: center"
      type="card"
      :interval="4000"
      height="300px"
      indicator-position="none"
      arrow="never"
    >
      <el-carousel-item
        v-for="item in linkList"
        :key="item.id"
        :title="item.title"
        class="carouselItem"
      >
        <img
          :src="indexImgPath + item.imgUrl"
          :style="
            item.shape === 'round'
              ? 'border-radius:50%;-webkit-border-radius:50%;-moz-border-radius:50%;'
              : ''
          "
          @click="toLink(item.url)"
        />
        <p @click="toLink(item.url)">{{ item.title }}</p>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
import { pathConfig } from '../assets/util/baseConfig'

export default {
  props: ['linkList'],
  data() {
    return {
      indexImgPath: pathConfig.indexImgPath
    }
  },
  watch: {
    linkList(val) {
      if (Array.isArray(val) && val.length > 0) {
        this.$nextTick(() => {
          this.resizeHeight()
        })
      }
    }
  },
  mounted() {
    let _this = this

    window.addEventListener('resize', function () {
      setTimeout(() => {
        _this.resizeHeight()
      }, 1)
    })
  },
  methods: {
    toLink(url) {
      window.open(url, '_blank')
    },
    resizeHeight() {
      let currentWidth = document.getElementById('bottomLink').offsetWidth

      document.getElementById('bottomLink').style.height =
        currentWidth / 3 + 5 + 'px'
      document.getElementById('indexLinks').style.height =
        currentWidth / 3 + 5 + 'px'
      let bottomItemList = document.getElementsByClassName('indexBottom')

      for (let i = 0; i < bottomItemList.length; i++) {
        bottomItemList[i].style.height = currentWidth / 3 + 5 + 'px'
      }

      let carouselItemList = document.getElementsByClassName('carouselItem')

      for (let i = 0; i < carouselItemList.length; i++) {
        carouselItemList[i].children[1].style.width =
          (currentWidth / 300 - 1) * 100 + 'px'
      }
    }
  }
}
</script>
<style  scoped>
.seamless-warp2 {
  overflow: hidden;
  height: 200px;
  border: 1px solid #e0dddd;
}

li {
  float: left;
  margin-right: 10px;
  width: 183px;
  height: 200px;
}
.ul-item {
  list-style: none;
  margin: 0;
  padding: 0;
  width: 1580px;
}
.logo {
  height: 100px;
  margin-top: 25px;
  border-radius: 50%;
  background: #eeeeee;
  box-shadow: 0 0 8px 4px #d0d0d0;
}
.logoTitle {
  display: inline-block;
  width: 100px;
  text-align: center;
  margin-top: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/bottomLink.vue